import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllServiceData } from '../../Services/allservicesdataApi';

function Allservicesdata() {
    const [servicesData, setServicesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch service data when the component mounts
    useEffect(() => {
        fetchServicesData();
    }, []);

    const fetchServicesData = async () => {
        try {
            const data = await getAllServiceData();
            console.log('Fetched data:', data); // <-- Log the data here
            setServicesData(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching service data:', error.message);
            setError('Failed to fetch data. Please try again later.');
            setLoading(false);
        }
    };


    return (
        <>
            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        {/* Start Content*/}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">All Services</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">All Services Data</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="header-title">All Services Data</h4>
                                            {loading ? (
                                                <p>Loading data...</p>
                                            ) : error ? (
                                                <p className="text-danger">{error}</p>
                                            ) : (
                                                <div className="tab-content">
                                                    <div className="tab-pane show active" id="basic-datatable-preview">
                                                        <table id="basic-datatable" className="table table-striped dt-responsive nowrap w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Service Type</th>
                                                                    <th>First Name</th>
                                                                    <th>Date of Birth</th>
                                                                    <th>Mobile</th>
                                                                    <th>Pincode</th>
                                                                    <th>Email</th>
                                                                    <th>Address</th>
                                                                    <th>Created Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Array.isArray(servicesData) && servicesData.length > 0 ? (
                                                                    servicesData.map((service) => (
                                                                        <tr key={service.id}>
                                                                            <td>{service.id}</td>
                                                                            <td>{service.serviceType}</td>
                                                                            <td>{service.firstName}</td>
                                                                            <td>{service.dob}</td>
                                                                            <td>{service.mobile}</td>
                                                                            <td>{service.pincode}</td>
                                                                            <td>{service.email}</td>
                                                                            <td>{service.address}</td>
                                                                            <td>{new Date(service.createdDate).toLocaleString()}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div> {/* end preview*/}
                                                </div> /* end tab-content*/
                                            )}
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Allservicesdata;
